import { render, staticRenderFns } from "./AksesCabang.vue?vue&type=template&id=51e16db3"
import script from "./AksesCabang.vue?vue&type=script&lang=js"
export * from "./AksesCabang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports